// @oasis-permission-inherits: /ai-edits (studio-edits:view)
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";

import { AgaveOperationGraphRoute } from "~/modules/agave-operations/components/agave-operation-graph-route";

const searchSchema = z.object({
  q: z.string().optional(),
});

export const Route = createFileRoute("/_dash/ai-edits/agave-operation-graph")({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { q } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <AgaveOperationGraphRoute
      query={q}
      onSearch={(nextQuery) => {
        navigate({ search: { q: nextQuery } });
      }}
    />
  );
}
